// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SubmitSelfStudyInstructorResponseHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import ResultDTO from '../models/ResultDTO';

interface Request {
    selfStudyResponseId: string | null;
    selfStudyId: string | null;
    secondaryProgramStatusTypeId: number | null | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            selfStudyResponseId: '00000000-0000-0000-0000-000000000000',
            selfStudyId: '00000000-0000-0000-0000-000000000000',
            secondaryProgramStatusTypeId: null,
        },
        initValues);
    },
    selfStudyResponseId: 'selfStudyResponseId',
    selfStudyId: 'selfStudyId',
    secondaryProgramStatusTypeId: 'secondaryProgramStatusTypeId',
}

interface Result extends ResultDTO {
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
        },
        initValues);
    },
}

export { Request, Result };